<template>
  <v-app
    light
    :style="myAppStyle"
  >
    <v-layout v-if="$route.name === 'area1'">
      <v-flex
        xs12
        sm8
        offset-sm2
        lg4
        offset-lg4
      >
      <img
        :src="groupBanner"
        style="width: 100%;"
        @error="bannerLoadError"
        @load="bannerImageLoaded"
      />
      <img
        v-if="logoDisplay && selectedArea && selectedArea.id !== 14"
        :src="groupLogo"
        class="group-logo"
        @error="logoLoadError"
      />
      </v-flex>
    </v-layout>
    <div v-else>
      <v-img
        class="mt-5 text-xs-center"
        :src="aptsysLogo"
        height="65px"
        contain
      ></v-img>
    </div>
    <v-content>
      <v-container fluid>
        <transition
          name="page"
          mode="out-in"
        >
          <router-view />
        </transition>
      </v-container>
    </v-content>
    <full-loading />
    <feedback-message />
    <dining-mode-dialog2 v-if="$route.name === 'area1'"></dining-mode-dialog2>
    <postal-code></postal-code>
    <group-footer v-if="selectedAreaMode" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '~/components/PageHeader'
import FeedbackMessage from '~/components/FeedbackMessage'
import FullLoading from '~/components/FullLoading'
import DiningModelDialog2 from '../components/DiningModelDialog2'
import PostalCode from '../components/PostalCode'
import GroupFooter from '../components/GroupFooter'

export default {
  name: 'group-layout',
  components: {
    PostalCode,
    'dining-mode-dialog2': DiningModelDialog2,
    'page-header': PageHeader,
    'feedback-message': FeedbackMessage,
    'full-loading': FullLoading,
    'group-footer': GroupFooter
  },
  data () {
    return {
      logoError: false,
      logoDisplay: true,
      bannerError: false,
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('area', [
      'selectedAreaMode', 'selectedArea'
    ]),
    myAppStyle () {
      return {
        backgroundColor: '#FFFFFF'
      }
    },
    aptsysLogo () {
      return window.config.sharedPictures + 'logo.png'
    },
    groupLogo() {
      return (!this.logoError && this.selectedArea) ? 'https://gemscms.aptsys.com.sg/gems_images/IOrderGroup/' + this.selectedArea.id + '/logo.png' : window.config.sharedPictures + 'logo.png';
    },
    groupBanner () {
      return (!this.bannerError && this.selectedArea) ? 'https://gemscms.aptsys.com.sg/gems_images/IOrderGroup/' + this.selectedArea.id + '/banner.png' : window.config.sharedPictures + 'sample_bg.jpg';
    },
  },
  mounted () {
    this.$store.dispatch('resetSelectedArea')
  },
  methods: {
    logoLoadError () {
      this.logoError = true
    },
    bannerLoadError () {
      this.bannerError = true
    },
    bannerImageLoaded () {
      // Hidden The Logo Image When The Banner Image Loaded
      // this.logoDisplay = false;
    }
  }
}
</script>

<style>
  .group-logo {
    width: 100px;
    height: 100px;
    margin-left: -50px;
    top: 100px;
    z-index: 200;
    position: absolute;
    left: 50%;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/group.vue